// CRM 2.0 stages after the Application for Booking (M3-F2 shell, prototype stAL / stFD / stREG / stAC).
// Their actions arrive with later modules (allotment letter eSign M8 — View & eSign, final draft M11, document desk M14);
// until then each stage shows its state from the booking and the step tracker.
// Registration shows Pratik's appointment section (M13).
import React from "react";
import Crm2PortalAppointment from "../../../Crm2Appointment/Crm2PortalAppointment";
import { Btn, NextBox, Steps, niceDate } from "../Crm2Parts";
import css from "../Crm2Booking.module.css";

const step2 = (card, code) => (card.steps?.[2] || []).find((s) => s.stepCode === code) || null;
const done = (s) => s?.status === "DONE";

export function AllotmentLetterStage({ card, actions = {} }) {
	const signed = !!card.dates?.allottedOn;
	// M8-F7: Allotment Letter pop-up (read the letter, choose who signs, Sign with Aadhaar)
	const view = actions.openLetter && <Btn primary={!signed} onClick={() => actions.openLetter()}>{signed ? "View Allotment Letter" : "View & eSign"}</Btn>;
	return (
		<>
			{signed ? (
				<NextBox who="done" title="Your unit is now Allotted" actions={view}>
					Allotment letter signed on {niceDate(card.dates.allottedOn)}. Your final cost sheet with the RERA accounts was sent by email and WhatsApp.
				</NextBox>
			) : (
				<NextBox who="you" title="Sign your allotment letter" actions={view}>
					Read the letter, choose who signs and sign with Aadhaar OTP. Your unit becomes Allotted when it is signed. We send you the link by email and WhatsApp.
				</NextBox>
			)}
			<Steps
				title="Allotment Letter"
				sub={signed ? "done" : "1 step for you"}
				rows={[
					["ok", "Allotment letter", "Issued · all applicants named", null],
					[signed ? "ok" : "now", "Aadhaar eSign", signed ? `Signed ${niceDate(card.dates.allottedOn)}` : "Any one applicant", null],
					[signed ? "ok" : "todo", "Final cost sheet + RERA accounts", signed ? "Sent by email and WhatsApp" : "Comes after the eSign, usually within an hour", null],
				]}
			/>
			{/* M8-F4 (M8.7 / M8.22, prototype stAL) */}
			<div className={css.lock} style={{ marginTop: "1rem" }}>Locked after the allotment letter: applicants, price, parking and discounts can no longer change.</div>
		</>
	);
}

export function FinalDraftStage({ card }) {
	const ok = card.stage > 3;
	const fd = step2(card, "FINAL_DRAFT");
	return (
		<>
			{ok ? (
				<NextBox who="done" title="Final draft confirmed">Confirmed by OTP by every applicant. Next: registration appointment.</NextBox>
			) : done(fd) || fd?.status === "PENDING" ? (
				<NextBox who="vj" title="Your final agreement is being prepared">We tell you by email and WhatsApp when it is ready to read and confirm by OTP.</NextBox>
			) : null}
			<Steps
				title="Final Draft"
				sub={ok ? "done" : "1 step for you"}
				rows={[
					[ok ? "ok" : "wait", "Final draft", ok ? "Ready" : "Being prepared by VJ", null],
					[ok ? "ok" : "todo", "Confirm by OTP", ok ? "Confirmed by every applicant" : "Every applicant · stops the agreement days", null],
				]}
			/>
		</>
	);
}

export function RegistrationStage({ card, allotment }) {
	const regDone = card.stage > 4;
	return (
		<>
			{regDone ? (
				<NextBox who="done" title="Registered">Your original agreement comes back to the VJ office; we will tell you when it is ready.</NextBox>
			) : (
				<NextBox who="you" title="Registration appointment">All applicants come to the Sub-Registrar office with original Aadhaar and PAN. Your CRM keeps you updated by email and WhatsApp.</NextBox>
			)}
			{!regDone && <Crm2PortalAppointment allotmentPaymentId={allotment.allotmentPaymentId} />}
			<Steps
				title="Registration"
				sub={regDone ? "done" : "VJ prepares, you attend"}
				rows={[
					[done(step2(card, "APPOINTMENT")) || regDone ? "ok" : "now", "Appointment", done(step2(card, "APPOINTMENT")) || regDone ? "Booked" : "To book", null],
					[done(step2(card, "STAMP")) || regDone ? "ok" : "todo", "Stamp duty paid by VJ", "From your stamp duty & charges", null],
					[done(step2(card, "DOCUMENT_PRINT")) || regDone ? "ok" : "todo", "Agreement signed by VJ", "Before the appointment", null],
					[regDone ? "ok" : "todo", "Registration at the office", "All applicants attend", null],
				]}
			/>
		</>
	);
}

export function CompleteStage() {
	return (
		<>
			<NextBox who="done" title="Agreement Complete">Your agreement is registered. Thank you for choosing VJ.</NextBox>
			<Steps
				title="Agreement Complete"
				sub="done"
				rows={[
					["ok", "Registered", "Index II with VJ", null],
					["now", "Original agreement", "Collect it at the VJ Document Desk; we send an OTP to the applicant at the desk", null],
				]}
			/>
		</>
	);
}
